import { updateRequestsTableConfig } from '../../../api'
import { USER_REQUESTS_ENTITY } from '../../../constants/entity'
import { RequestWizardDraft } from '../../../context'
import { withDraftProviders } from '../../Draft'
import { EntityTabRequests, getEntityTabFilterStateApi } from '../../EntityTab'
import {
  RequestDraftProvider,
  toRequestFormApplicantSelectOption,
} from '../../Request'
import { useUserProfileContext } from '../../User'

import {
  USER_PROFILE_TAB_REQUESTS_OWNER_FILTER_KEY,
  USER_PROFILE_TAB_REQUESTS_QA_NAME,
  USER_PROFILE_TAB_REQUESTS_REQUEST_DRAFT_PREFIX,
  USER_PROFILE_TAB_REQUESTS_REQUEST_WIZARD_DRAFT_PREFIX,
} from './UserProfileTabRequests.constants'
import { useUserProfileTabRequestsCounters } from './UserProfileTabRequests.hooks'
import {
  getShouldShowCreateRequestAction,
  getUserProfileTabRequestsCreationInitialValues,
} from './UserProfileTabRequests.utils'

function UserProfileTabRequests({
  entity = USER_REQUESTS_ENTITY,
  scopeFilterKey = USER_PROFILE_TAB_REQUESTS_OWNER_FILTER_KEY,
  userData,
  onReloadTabCounters,
}) {
  const { registerRequestsTabReload } = useUserProfileContext()

  const userId = userData?.id

  const { counters, handleLoadCounters } = useUserProfileTabRequestsCounters({
    scopeFilterKey,
    userId,
  })

  async function handleApplyTableConfig(data) {
    return updateRequestsTableConfig(data, entity.plural)
  }

  return (
    <EntityTabRequests
      canViewArchive={userData?.permissions?.can_view_archived_requests}
      counters={counters}
      creationInitialUser={toRequestFormApplicantSelectOption(userData)}
      creationInitialValues={getUserProfileTabRequestsCreationInitialValues(
        userData
      )}
      entity={entity}
      filterStateApi={getEntityTabFilterStateApi({
        entityPlural: entity.plural,
        objectId: userId,
      })}
      qaName={USER_PROFILE_TAB_REQUESTS_QA_NAME}
      scopeFilterKey={scopeFilterKey}
      scopeId={userId}
      shouldShowCreateAction={getShouldShowCreateRequestAction(userData)}
      onApplyTableConfig={handleApplyTableConfig}
      onRegisterReload={registerRequestsTabReload}
      onReloadCounters={onReloadTabCounters}
      onReloadOwnCounters={handleLoadCounters}
    />
  )
}

export default withDraftProviders(UserProfileTabRequests, [
  {
    Provider: RequestDraftProvider,
    prefix: USER_PROFILE_TAB_REQUESTS_REQUEST_DRAFT_PREFIX,
  },
  {
    DraftContext: RequestWizardDraft,
    Provider: RequestDraftProvider,
    prefix: USER_PROFILE_TAB_REQUESTS_REQUEST_WIZARD_DRAFT_PREFIX,
  },
])
